// extracted by mini-css-extract-plugin
module.exports = {"attachmentList":"Attachments_attachmentList__14hB4"};